import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms'
import { Router } from '@angular/router'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { ToastrService } from 'ngx-toastr'
import { AuthService } from '../auth.service'
import { AuthStateService } from '../auth-state.service'

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatProgressBarModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({})
  isLoading: boolean = false
  submitted: boolean = false
  showPassword: boolean = false
  constructor(
    private authService: AuthService,
    private authStateService: AuthStateService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.initializeForm()
  }

  initializeForm() {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login() {
    this.submitted = true
    if (this.loginForm.invalid) {
      return
    }
    this.isLoading = true
    this.authService.login(this.loginForm.value).subscribe({
      next: (response: any) => {
        this.isLoading = false
        this.authStateService.setUserInformation(response)
        this.authStateService.setLoggedIn(true)
        this.router.navigateByUrl('/')
      },
      error: (error: any) => {
        this.isLoading = false
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        console.error('Login error', error)
      },
    })
  }
}
